<template>
  <div class="boss-layout-block">
    <table class="boss-table-4 boss-table-4-custom">
      <tr>
        <th rowspan="2">
          候補日時
        </th>
        <td data-test="first-candidate-date">
          第一候補 {{ candidateDates[0] | formatDate }}
        </td>
      </tr>
      <tr>
        <td data-test="second-candidate-date">
          第二候補 {{ candidateDates[1] | formatDate('指定なし') }}
        </td>
      </tr>
      <tr>
        <th>場所</th>
        <td data-test="place">
          {{ place }}
        </td>
      </tr>
      <tr>
        <th>所要時間</th>
        <td data-test="duration">
          {{ duration | formatMinutes }}
        </td>
      </tr>
      <tr
        v-if="contentNames && contentNames.length"
        data-test="contents-tr"
      >
        <th>内容</th>
        <td data-test="contents">
          {{ contentNames | formatJoinComm }}
        </td>
      </tr>
      <tr
        v-if="remarks"
        data-test="remarks-tr"
      >
        <th>備考</th>
        <td
          class="pega-pre-wrap"
          data-test="remarks"
          v-text="remarks"
        />
      </tr>
    </table>
  </div>
</template>

<script>
import { createDate } from '@/lib/dateUtils.js'
import _ from 'lodash'

export default {
  filters: {
    formatDate (val, defaultLabel = '') {
      return createDate(val)?.format('YYYY/MM/DD(ddd) HH:mm') ?? defaultLabel
    },
    formatMinutes (val) {
      return val ? `${val}分` : '指定なし'
    },
    formatJoinComm (val) {
      return _.join(val, '、')
    }
  },
  props: {
    candidateDates: {
      type: Array,
      default: () => []
    },
    place: {
      type: String,
      default: ''
    },
    duration: {
      type: Number,
      default: undefined
    },
    contentNames: {
      type: Array,
      default: () => []
    },
    remarks: {
      type: String,
      default: ''
    }
  }
}
</script>
